import { createStorefrontApiClient } from '@shopify/storefront-api-client';

// Token is optional — Shopify supports tokenless access for products & cart.
// If REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN is set it will be used,
// otherwise requests run in tokenless mode (query complexity limit: 1,000).
const clientConfig = {
    storeDomain: process.env.REACT_APP_SHOPIFY_STORE_DOMAIN,
    apiVersion: '2026-04',
};

if (process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN) {
    clientConfig.publicAccessToken = process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN;
}

const client = createStorefrontApiClient(clientConfig);

export default client;
